import React, { useState } from 'react';
import { ReactComponent as LotIcon } from 'Icons/Sidebar/Lot.svg';
import { ReactComponent as Edit } from 'Icons/CommandPanel/Edit.svg';
import { ReactComponent as Delete } from 'Icons/CommandPanel/Delete.svg';
import { ReactComponent as Print } from 'Icons/Sidebar/Print.svg';
import { IExperimentScreenLot } from 'business/models/Models';
import { getContainerName, showAlertSnackBar } from 'utils/Global';
import PlateService from 'business/services/PlateService';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { ModalDetails } from 'business/models/CustomModels';
import RMModal from 'components/modal/RMModal';
import { useShowLabelPrinterError } from 'CustomHooks';
interface Props {
  lot: IExperimentScreenLot;
  setSelectedLot: (lot: IExperimentScreenLot) => void;
  deleteLot: (lot: IExperimentScreenLot) => void;
}
export default function Lot(props: Props) {
  const { lot, setSelectedLot, deleteLot } = props;
  const showLabelPrinterError = useShowLabelPrinterError();
  const [modalDetails, setModalDetails] = useState<ModalDetails>({
    showModal: false,
    setShowModal: () => {},
    onOk: () => {},
    body: null,
    heading: '',
    isOkOnly: false,
    okButtonText: undefined,
    noButtonText: undefined,
    showButtons: true,
    dialogClassName: '',
    isCancelOnly: false,
  });

  const printScreenLotBarcode = async (lot) => {
    showAlertSnackBar(EAlertType.INFO, ESnackBarPosition.TOP, 'Sent for print barcode.');
    const plateService = new PlateService();
    const printResponse = await plateService.printScreenLotBarcode(lot.id);
    if (printResponse.value != '') {
      showLabelPrinterError();
    }
  };

  return (
    <>
      <RMModal id='screenlot-lot-modal'
        showModal={modalDetails.showModal}
        setShowModal={() => setModalDetails({ ...modalDetails, showModal: false })}
        onOk={modalDetails.onOk}
        body={modalDetails.body}
        heading={modalDetails.heading}
        isOkOnly={modalDetails.isOkOnly}
        okButtonText={modalDetails.okButtonText}
        dialogClassName={modalDetails.dialogClassName}
        isCancelOnly={modalDetails.isCancelOnly}
      />
      <div id={`screenlot-lotcard-${lot.id}`} className="ingredient-card">
        <div id={`screenlot-lotcard-header-${lot.id}`} className="flex ing-icons  flex-space-between flex-y-center">
          <LotIcon id={`screenlot-lotcard-icon-${lot.id}`} />
        </div>
        <div id={`screenlot-lotcard-content-${lot.id}`} className="flex flex-column ing-content">
          <div id={`screenlot-lotcard-number-${lot.id}`} className="ingredient-card-text">
            {` Lot# : ${lot.lotNumber} (${getContainerName(lot.containerId)})`}
          </div>
          <div id={`screenlot-lotcard-comment-${lot.id}`} className="ingredient-card-text ing-card-light">
            Comment: {lot.comment}
          </div>
          <div id={`screenlot-lotcard-dispensevol-${lot.id}`} className="ingredient-card-text ing-card-light">
            Dispense Volume: {lot.dispenseVol} μL
          </div>
          <div id={`screenlot-lotcard-currentvol-${lot.id}`} className="ingredient-card-text ing-card-light">
            Current Volume: {lot.currentVol} μL
          </div>
        </div>
        <div id={`screenlot-lotcard-actions-${lot.id}`} className="flex ing-delete-update-enabled flex-space-between">
          <Print id={`screenlot-lotcard-print-${lot.id}`} onClick={() => printScreenLotBarcode(lot)} className="cursor-pointer" />
          <Edit id={`screenlot-lotcard-edit-${lot.id}`} onClick={() => setSelectedLot(lot)} className="cursor-pointer" />
          <Delete
            id={`screenlot-lotcard-delete-${lot.id}`}
            onClick={() => deleteLot(lot)}
            className="cursor-pointer"
            style={{ visibility: lot.lotNumber === 0 ? 'hidden' : 'visible' }}
          />
        </div>
      </div>
    </>
  );
}
